import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { wenji } from 'libraries/interfaces/IWenji';

@Injectable()
export class TitleService {
    public constructor(
        private readonly title: Title
    ) { }

    public setTitle(...titles: string[]): void {
        this.title.setTitle(
            [...(titles || []), wenji.sasha.name].join(" - ")
        );
    }
}